import {
  SET_ACTIVE_LINK,
  SET_ACTIVE_LINK_CANDIDATE,
  SET_BACK_ARROW_VISIBILITY,
  SidebarActiveLinkAction
} from "../actions/sidebar";

export interface SidebarActiveLinkReducer {
  activeLink: string;
  activeLinkCandidate: string;
  shouldBackArrowBeShown: boolean;
}

const initialState: SidebarActiveLinkReducer = {
  activeLink: "/",
  activeLinkCandidate: "",
  shouldBackArrowBeShown: false
};

export default (
  state = initialState,
  action: SidebarActiveLinkAction
): SidebarActiveLinkReducer => {
  switch (action.type) {
    case SET_ACTIVE_LINK:
      return {
        ...state,
        activeLink: action.activeLink
      };
    case SET_ACTIVE_LINK_CANDIDATE:
      return {
        ...state,
        activeLinkCandidate: action.activeLinkCandidate
      };
    case SET_BACK_ARROW_VISIBILITY: {
      return {
        ...state,
        shouldBackArrowBeShown: action.shouldBackArrowBeShown
      };
    }
    default:
      return state;
  }
};
